export default "__VITE_ASSET__CSggmRgR__"